import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import classNames from "classnames";
import { random, omit } from "lodash";
import { TRACKED_CLASSES_AUDIBLE } from "../../../modules/ads/click_tracking_helper";
import ClickTrackingWrapper from "../../click_tracking_wrapper";

import Book from "../../book";
import BookDescription from "../../book_description";
import WantToRead from "../../want_to_read/want_to_read_button";

export default GrComponentFactory.createClass({
  displayName: "SponsoredBook",

  propTypes: {
    widgetTitle: React.PropTypes.string,
    showAudibleCommand: React.PropTypes.bool,
    sponsoredBookExternalLinkUrl: React.PropTypes.string,
    sponsoredBookExternalLinkText: React.PropTypes.string,
    bookAci: React.PropTypes.string,
    requestOriginUrl: React.PropTypes.string,
    randomRequestParam: React.PropTypes.string,
    audiobookHost: React.PropTypes.string,
  },

  getDefaultProps () {
    return {
      trackingOptions: {
        enableTracking: true,
      },
    };
  },

  renderTitle () {
    if (this.props.widgetTitle) {
      return (<h3>{this.props.widgetTitle}</h3>);
    }
    return null;
  },

  renderExternalLink () {
    if (this.props.sponsoredBookExternalLinkUrl) {
      const externalLink = (<form target="_blank" rel="noopener noreferrer"><button formAction={this.props.sponsoredBookExternalLinkUrl} className="gr-button">
        {this.props.sponsoredBookExternalLinkText}
      </button></form>);
      return (<div className={"gr-sponsoredBook-ControlContainer"}>
        <ClickTrackingWrapper children={externalLink} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookExternalLink}/>
      </div>);
    }
    return null;
  },

  render () {
    const wantToReadProps = {
      bookId: this.props.bookId,
      bookTitle: this.props.title,
      uniqueId: random(10000).toString(),
      showStars: true,
      showMenu: true,
    };
    const classnames = classNames(["gr-sponsoredWidget", "gr-sponsoredBook"]);
    const props = omit(this.props, "trackingOptions");

    return (<div className={classnames}>
      {this.renderTitle()}
      <Book size="large" {...props} bookImageTrackingData={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookImage}
                                         bookTitleTrackingData={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookTitle}
                                         authorLinkTrackingData={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_AuthorLink}>
        <WantToRead {...wantToReadProps} trackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_WantToRead} starsTrackingOptions={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_Stars}/>
        <BookDescription bookDescription={this.props.description}
                         className={"gr-book__description u-marginTopXSmall"}
                         bookDescriptionTargetingData={TRACKED_CLASSES_AUDIBLE.AEP_Desktop_Sponsored_BookDescription}/>
        <div>
          {this.renderExternalLink()}
        </div>
      </Book>
    </div>);
  },
});
